import { Dispatch } from 'redux'
import store, { UpgradePortalStore } from '../stores/store'
import UpgradePlanConfiguration from '../services/upgrade_plan_config'
import { PlanRepository } from '../repositories/upgrade_plan'
import { loadUpgradePlanAsync } from './load_upgrade_plan'
import { sharedLinkRestoreNeedsReview } from './shared_link_restore_status'

// Runs once, after a shared link has finished restoring its products. Asks the same
// question the Generate Plan button asks before it lets itself be clicked, and on a yes
// calls the same action that button calls - so success rendering and every server-error
// path stay identical whether a human clicked or we did it for them.
export function attemptAutoGenerateFromSharedLinkAsync(
  upgradePlanRepository: PlanRepository,
  getState: () => UpgradePortalStore = () => store.getState()
) {
  return (dispatch: Dispatch): Promise<void> => {
    const {chosenProducts, diagnosticReportImported} = getState()
    const upgradeConfig = new UpgradePlanConfiguration(chosenProducts, diagnosticReportImported)

    if (!upgradeConfig.isValid()) {
      dispatch(sharedLinkRestoreNeedsReview())
      return Promise.resolve()
    }

    return Promise.resolve(loadUpgradePlanAsync(upgradePlanRepository, upgradeConfig)(dispatch))
      .then(() => undefined)
  }
}
